<div class="inventory-modal">
    <div class="inventory-modal__header">
        <i class="material-icons inventory-modal__close-button" (click)="onNoClickPopup()" matTooltip="Close Popup">
            close
        </i>
    </div>
    <div class="inventory-modal__content">
        <mat-form-field class="input-action">
            <mat-label> {{ 'Select Action' | translate | async }} </mat-label>
            <mat-select [(ngModel)]="system.ActionSelectionId" (selectionChange)="onTopActionChanged()">
                <mat-option [value]="1">{{ 'No Action' | translate | async }} </mat-option>
                <mat-option [value]="2"> {{ 'Replace' | translate | async }} </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="system.ActionSelectionId == 2" class="input-serial">
            <mat-label> {{ 'Select Action Type' | translate | async }} </mat-label>
            <mat-select [(ngModel)]="system.SysReplaceActionId" (selectionChange)="onTopActionTypeChanged()" required>
                <mat-option *ngIf="system.SystemType == 2" [value]="3"> New Components </mat-option>
            </mat-select>
        </mat-form-field>

        
      <mat-form-field class="input">
        <input matInput [matDatepicker]="myDatepicker" placeholder="Date of Action" [(ngModel)]="ActionDate">
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker></mat-datepicker>
      </mat-form-field>

       <mat-form-field class="action-input" style="   max-width: 100px;">
        <mat-label> {{ 'Frame Hours' | translate | async }} </mat-label>
            <input matInput type="number" [(ngModel)]="NewSMU" required>
          </mat-form-field>
    
    </div>
      <div class="center" *ngIf="componentList == null || isLoading==true">
      <mat-spinner></mat-spinner>
    </div>
    <table class="table table--striped table--full-width" *ngIf="isLoading== false">
        <thead>
            <tr>
                <th>Component</th>
                <th>Pos</th>
                <th>Brand</th>
                <th>CMU</th>
                <th>Worn %</th>
                <th>Action Selection</th>
                <th>Action Type</th>
                <th>Available Replacement</th>
                <th>Brand</th>
                <th>Worn %</th>
                <th>Budget Life</th>
                <th>CMU</th>
                <th>Cost</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let component of componentList">
                <td>{{ component.Name }} </td>
                <td>{{ component.Pos }}</td>
                <td>{{ component.Brand }} </td>
                <td>{{ component.CMU }} </td>
                <td>{{ component.WornPercentage | number:'1.2-2' }}</td>
                <td>
                    <mat-form-field style="max-width: 100px;">
                        <mat-select placeholder="Select Action" [(ngModel)]="component.ActionSelectionId"
                            (selectionChange)="GetAvailableActions(component)">
                            <mat-option [value]="1"> No Action</mat-option>
                            <mat-option [value]="2"> Replace</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field>
                        <mat-select placeholder="Select Action Type" [(ngModel)]="component.SelectedActionTypeId"
                            (selectionChange)="actionChanged($event, component)" required>

                            <mat-option *ngFor="let action of component.AvailableActions" [value]="action.ActionTypeId">
                                {{ action.ActionTypeName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>

                    <mat-form-field>
                        <mat-select placeholder="Select Available Replacement"
                            [(ngModel)]="component.ReplaceComponentCompartId"
                            (selectionChange)="OnSelectedReplacementCompart($event, component)" required>

                            <mat-option *ngFor="let action of component.availableCompartments" [value]="action.Id">
                                {{ action.Name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>

                    <mat-form-field style="max-width: 110px;" *ngIf="component.ActionSelectionId == 2">
                        <mat-select placeholder="Select Brand" [(ngModel)]="component.ActionBrandId">
                            <mat-option *ngFor="let make of Makes" [value]="make.Id">
                                {{ make.Title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <input style="width: 100px; text-align: center;" [value]="component.ActionWorn ?? ''">
                    <!--
                    (focusout)="ChangesWorn(component,$event,system)"
                    [disabled]="allowWornInput(
                        system.SysReplaceActionId,
                        component.SelectedActionTypeId
                    )"
                    -->
                </td>
                <td>
                    <input style="width: 100px; text-align: center;" [(ngModel)]="component.ActionBudgetLife">
                    <!--
                    (focusout)="ChangesBudgetLife(component,$event,system)"
                    -->
                </td>
                <td>
                    <input style="width: 100px; text-align: center;" [(ngModel)]="component.ActionCMU">
                </td>
                <td>
                    <input style="width: 100px; text-align: center;" [(ngModel)]="component.ActionCost">
                </td>
            </tr>
        </tbody>
    </table>
    <div class="inventory-modal__footer">

    <button type="button"  class="inventory-modal__save-button"  mat-raised-button   color="warn"  [disabled]="Buttondisabled" (click)="RecordActions()">
        <mat-spinner *ngIf="Buttondisabled" diameter="18" class="save-spinner"> </mat-spinner>
        <i class="material-icons" *ngIf="!Buttondisabled">  save </i>
        <span>{{ Buttondisabled ? 'Saving...' : 'Save' }}</span>
    </button>

</div>
</div>